import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';
import { SPACE } from '@tcaster/tcaster-theme';

import { ResponsiveBox } from '../../../../../Components/Base';
import { QueryComponent } from '../../../../../GraphQL';
import { queryMyMockExamHistory } from '../../../../../GraphQL/query/MockExam.query';
import { RankingChartTable, ScoreRangeTable } from '../../../../../Components/Table';

const prepareHistogram = histogram => {
  if (!histogram) return [];
  const {
    percent,
    count,
    range: { min, max },
  } = histogram;
  const histoRange = (max - min) / 10;
  return count.map((r, i) => {
    const start = i * histoRange;
    const end = start + histoRange;
    const value = r;
    const percentValue = percent[i];
    return { range: { start, end }, value, percent: percentValue };
  });
};

const getRangeArr = (range, arrLength) => {
  const { max, min } = range;
  const interval = (max - min) / arrLength;
  const rangeArr = [];

  for (let i = 0; i < arrLength; i++) {
    const start = i * interval;
    const end = start + interval;
    rangeArr.push([start, end]);
  }
  return rangeArr;
};

const getTableScore = (score, columns) => {
  const columnIndex = columns.findIndex(column => {
    return column[0] <= score && score <= column[1];
  });
  return { value: score, columnIndex: columnIndex };
};

const ExamStat = ({
  mockExamId,
  examTitle,
  subjectName,
  score,
  rank,
  chartTitle,
  tableTitle,
  color,
  scoreVariant,
}) => (
  <QueryComponent query={queryMyMockExamHistory} variables={{ mockExamId: mockExamId }}>
    {data => {
      const {
        averageScore,
        sdScore,
        minimumScore,
        maximumScore,
        histogram,
        examAttendee,
        fullScore,
      } = data.mockExamResult;
      // data for <RankingChartTable />.
      const preparedHistogram = prepareHistogram(histogram);

      // data for <ScoreRangeTable />.
      const { count, percent, range } = histogram;
      const columns = getRangeArr(range, count.length);
      const tableScore = getTableScore(score, columns);

      return (
        <Box mb={SPACE.xlarge}>
          <Box mb={SPACE.large}>
            <RankingChartTable
              title={chartTitle}
              chartData={preparedHistogram}
              score={score}
              fullScore={fullScore}
              max={maximumScore}
              min={minimumScore}
              avg={averageScore}
              sd={sdScore}
              rank={rank}
              totalRank={examAttendee}
              chartVariant={color}
              isPercentValue={false}
              xLabel={`คะแนนวิชา ${subjectName}`}
              yLabel="จำนวน"
              scoreVariant={scoreVariant}
              // onClick={() => {}}
            />
          </Box>
          <ResponsiveBox display={['none', null, 'block']}>
            <ScoreRangeTable
              title={tableTitle}
              studentCountRow={count}
              percentageRow={percent}
              columns={columns}
              score={tableScore}
              examTitle={examTitle}
              themeColor={color}
              scoreVariant={scoreVariant}
            />
          </ResponsiveBox>
          <ResponsiveBox display={['block', null, 'none']}>
            <ScoreRangeTable
              variant={'vertical'}
              title={tableTitle}
              studentCountRow={count}
              percentageRow={percent}
              columns={columns}
              score={tableScore}
              examTitle={examTitle}
              themeColor={color}
              scoreVariant={scoreVariant}
            />
          </ResponsiveBox>
        </Box>
      );
    }}
  </QueryComponent>
);

ExamStat.propTypes = {
  mockExamId: PropTypes.string,
  subjectName: PropTypes.string,
  score: PropTypes.number,
  rank: PropTypes.number,
  chartTitle: PropTypes.string,
  tableTitle: PropTypes.string,
};

export default ExamStat;
